module.exports = __webpack_public_path__ + "static/raw-6aced4b9db17e9ec667d044f193d859d.png";